import React from 'react';
import { Outlet, Link } from 'react-router-dom';

function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-gray-900 text-white py-4">
        <div className="container mx-auto px-4 lg:px-12 flex items-center justify-between">
          <Link to="/login" className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_barber-supply/artifacts/m8xbva3r_file_000000005a2c71f490cada719be81da8.png"
              alt="ED STEEL"
              className="h-10 w-auto"
            />
            <span className="font-heading font-bold text-xl tracking-wider">ED STEEL</span>
          </Link>
          <Link 
            to="/login" 
            className="px-4 py-2 bg-white text-gray-900 rounded-md font-medium hover:bg-gray-100 transition-colors"
          >
            Anmelden
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white mt-auto">
        <div className="container mx-auto px-4 lg:px-12 py-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Logo & Kontakt */}
            <div>
              <img
                src="https://customer-assets.emergentagent.com/job_barber-supply/artifacts/m8xbva3r_file_000000005a2c71f490cada719be81da8.png"
                alt="ED STEEL"
                className="h-10 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-gray-400 text-sm">
                B2B Großhandel für Barbershops und Friseursalons
              </p>
              <div className="mt-4 text-gray-400 text-sm">
                <p>Telefon: +49 171 629 5816</p>
                <p>E-Mail: ed-steel@outlook.de</p>
              </div>
            </div>

            {/* Anmelden */}
            <div>
              <h3 className="font-bold mb-4 text-lg">Zugang</h3>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><Link to="/login" className="hover:text-white transition-colors">Anmelden</Link></li>
                <li><Link to="/register" className="hover:text-white transition-colors">Registrieren</Link></li>
              </ul>
            </div>

            {/* Informationen */}
            <div>
              <h3 className="font-bold mb-4 text-lg">Informationen</h3>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><Link to="/public/versand-zahlung" className="hover:text-white transition-colors">Versand & Zahlung</Link></li>
              </ul>
            </div>

            {/* Rechtliches */}
            <div>
              <h3 className="font-bold mb-4 text-lg">Rechtliches</h3>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><Link to="/public/impressum" className="hover:text-white transition-colors">Impressum</Link></li>
                <li><Link to="/public/agb" className="hover:text-white transition-colors">AGB</Link></li>
                <li><Link to="/public/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link></li>
                <li><Link to="/public/widerruf" className="hover:text-white transition-colors">Widerrufsbelehrung</Link></li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-800 mt-8 pt-6 text-center text-gray-500 text-sm">
            <p>&copy; {new Date().getFullYear()} ED STEEL. Alle Rechte vorbehalten.</p>
            <p className="mt-1">Nur für Gewerbetreibende (B2B)</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PublicLayout;
